import { createAction } from 'redux-act';

export const fetchedBadges = createAction('fetched_badges');
export const handleError = createAction('handleError');
